// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"247":"688320d1","333":"72e317c6","625":"e74a961c","815":"15d9dfcb"}[chunkId] + ".css";
};